export const SUBJECT = 'Subject';
export const DOMAIN = 'Domain';
export const GOAL = 'Goal';
